﻿import { Page } from '@shopify/polaris'
import { RecommendationsPanel } from '@/components/recommendations/RecommendationsPanel'

export function RecommendationsPage() {
  return (
    <Page fullWidth title="Recommendations" subtitle="AI-generated suggestions to improve your store">
      <RecommendationsPanel />
    </Page>
  )
}
